// extracted by mini-css-extract-plugin
module.exports = {"container":"TwoFactorConfigureOverlay__container___8QuSE","inner-wrapper":"TwoFactorConfigureOverlay__inner-wrapper___TTf3m"};